export default __webpack_public_path__ + "static/media/terms-of-service-consent-kr-2.43989ae0.jpg";